import ReactPaginate from 'react-paginate';
import './Pagination.css';

interface PaginationProps {
  pageCount: number;
  currentPage: number;
  onPageChange: (page: number) => void;
  nextLabel?: string | React.ReactNode;
  previousLabel?: string | React.ReactNode;
  pageRangeDisplayed?: number;
  marginPagesDisplayed?: number;
}

const Pagination = ({
  pageCount,
  currentPage,
  onPageChange,
  nextLabel,
  previousLabel,
  pageRangeDisplayed = 3,
  marginPagesDisplayed = 1,
}: PaginationProps) => {
  const handlePageClick = ({ selected }: { selected: number }) => {
    onPageChange(selected + 1);
  };

  return (
    <ReactPaginate
      forcePage={currentPage - 1}
      breakLabel="..."
      nextLabel={nextLabel}
      previousLabel={previousLabel}
      onPageChange={handlePageClick}
      pageRangeDisplayed={pageRangeDisplayed}
      marginPagesDisplayed={marginPagesDisplayed}
      pageCount={pageCount}
      renderOnZeroPageCount={null}
      containerClassName="
        pagination
        flex
        items-center
        justify-end
        gap-[6px]
        w-full
      "
      pageClassName="
        flex
        items-center
        justify-center
      "
      pageLinkClassName="
        w-8
        h-8
        rounded-[8px]
        border
        border-db-border
        flex
        items-center
        justify-center
        title2
        text-text-black
        bg-transparent
        cursor-pointer
        transition-all
        duration-200
        hover:bg-text-blue-100/10
        hover:border-text-blue-100
      "
      activeClassName="active"
      activeLinkClassName="
        !bg-text-blue-100
        !text-white
        !border-text-blue-100
      "
      previousClassName="
        previous
        flex
        items-center
        justify-center
      "
      previousLinkClassName="
        h-8
        px-3
        rounded-[8px]
        border
        border-db-border
        flex
        items-center
        justify-center
        title2
        text-text-black
        bg-transparent
        cursor-pointer
        transition-all
        duration-200
        hover:bg-text-blue-100/10
        hover:border-text-blue-100
      "
      nextClassName="
        next
        flex
        items-center
        justify-center
      "
      nextLinkClassName="
        h-8
        px-3
        rounded-[8px]
        border
        border-db-border
        flex
        items-center
        justify-center
        title2
        text-text-black
        bg-transparent
        cursor-pointer
        transition-all
        duration-200
        hover:bg-text-blue-100/10
        hover:border-text-blue-100
      "
      disabledClassName="disabled opacity-30"
    />
  );
};

export default Pagination;
